<!--ngx-spinner bdColor = "rgba(149,40,40,0.03)" size = "medium" color = "#087B36" type = "ball-elastic-dots" [fullScreen] = "true"><p style="color: #087B36"></p></ngx-spinner-->
<app-toaster-container></app-toaster-container>
<router-outlet></router-outlet>